import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import strings from 'strings';

import { getRequiredNonBlankRules } from '../../utils';

import { useStyles } from './QuickEntryTextField.styled';

export const QuickEntryTextField = ({
  label,
  multiline = false,
  name,
  required = false,
  rows = 1,
  rules = {}
}) => {
  const classes = useStyles();
  const { control, errors } = useFormContext();

  const handleChange = useCallback(([event]) => event.target.value, []);
  const displayLabel = required ? `${label} *` : label;
  const requiredRules = required
    ? getRequiredNonBlankRules(
        strings.formatString(strings.shared.fields.fieldNameRequired, { name: label })
      )
    : {};

  return (
    <Controller
      as={
        <TextField
          autoComplete="off"
          classes={classes}
          error={!!errors[name]}
          fullWidth
          helperText={errors[name]?.message}
          id={name}
          label={displayLabel}
          multiline={multiline}
          rows={rows}
          variant="outlined"
        />
      }
      control={control}
      name={name}
      onChange={handleChange}
      rules={{ ...requiredRules, ...rules }}
    />
  );
};
